import React from 'react';

import { useFulfillmentPlanIdContext } from '../../../../../../../fulfillment-plans/context/fulfillment-plan-id-context-provider';
import { useIsSendNotificationEnabledForShipment } from '../../../../../../../fulfillment-plans/send-notifications/hooks';
import { useReturnIdContext } from '../../../../../context/return-id-context-provider';

import SendNotificationsButton from '../../../../../../../fulfillment-plans/send-notifications';

export const SendNotificationsMenuItem = () => {
  const fulfillmentPlanId = useFulfillmentPlanIdContext();
  const returnId = useReturnIdContext();
  const isEnabled = useIsSendNotificationEnabledForShipment(fulfillmentPlanId, returnId);

  return <SendNotificationsButton fulfillmentPlanId={fulfillmentPlanId} isEnabled={isEnabled} />;
};
